<template>
    <div class="d-flex flex-wrap pt-3 lottery-page" style="
        background-size: cover; 
        background: #FFFFFF;
        padding-bottom: 7rem;
        width: 100%;
    ">
        <div class="col-xl-12 home-cards">
            <div>
                <div class="row align-items-center pl-4 pb-4">
                    <div>
                        <h3
                            class="mb-0"
                            v-if="$store.state.language === 'en'"
                            style="color: #0D3B1A"
                        >
                            Recent 3d history
                        </h3>
                        <h3 class="mb-0" v-else style="color: #0D3B1A">
                            သုံးလုံးထွက်ပြီး ဂဏန်းများ
                        </h3>
                    </div>
                </div>
                <div>
                    <!-- Projects table -->
                    <table>
                        <thead>
                            <tr v-if="$store.state.language === 'en'">
                                <th
                                    scope="col"
                                    class="text-center table-header"
                                    style="color: #fff"
                                >
                                    Date
                                </th>
                                <th
                                    scope="col"
                                    class="text-center table-header"
                                    style="color: #fff"
                                >
                                    Result
                                </th>
                            </tr>
                            <tr v-else>
                                <th
                                    scope="col"
                                    class="text-center table-header"
                                    style="color: #fff"
                                >
                                    နေ့စွဲ
                                </th>
                                <th
                                    scope="col"
                                    class="text-center table-header"
                                    style="color: #fff"
                                >
                                    ရလဒ်
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(
                                    threeDhistory, index
                                ) in threeDHistories"
                                :key="index"
                            >
                                <td scope="row" class="text-center">
                                    
                                        {{
                                            threedDrawDateFormat(
                                                threeDhistory.draw_date
                                            )
                                        }}
                                    
                                </td>
                                <td class="text-center">
                                    {{ threeDhistory.result }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="bet-container">
            <button class="btn btn-primary custom-btn py-3 text-nowrap" @click="$router.push('/user/3d')">
                    {{
                        $store.state.language === "en"
                            ? "BET"
                            : "ထိုးမည်"
                    }}    
            </button>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      twoDdata: {},
      isLive: false,
      threeDHistories: {},
      interval: null,
      threedData: {},
    };
  },
  methods: {
    threedDrawDateFormat(date) {
      return moment(date).format('ll');
    },
    async fetchTwoDliveresult() {
      try {
        const res = await axios.get('/2d/data/live');
        this.twoDdata = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    fetchLive() {
      this.interval = setInterval(() => this.fetchTwoDliveresult(), 4000);
    },

    async fetchThreedDdata() {
      try {
        const res = await axios.get('/3d/data');
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const threeDres = await axios.get('/threed_history');
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
  unmount() {
    clearInterval(this.interval);
  },
  mounted() {
    this.fetchThreedDdata();
    this.fetchTwoThreeDHistories();
  },
};
</script>
<style scoped>
.custom-btn {
    background: #0D3B1A !important;
    color: #FFFFFF !important;
    border: none !important;
    font-weight: 700;
}


table {
        width: 100%;
        border-collapse: collapse;
        /* border-radius: 5px; */
        overflow: hidden;
        /* box-shadow: 0 0 20px rgba(0,0,0,0.1); */
    }

    th,
    td {
        padding: 10px !important;
        /* background-color: rgba(255,255,255,0.2); */
        /* color: #fff; */
        border: none !important;
        font-weight: 400 !important;
    }

    th {
        text-align: left;
    }

    thead {
        th {
            background: #0D3B1A;
            color: #FFFFFF;
        }
    }

    tbody {
        color: #0D3B1A;
        tr {
            &:hover {
                background-color: #E5EBE6;
            }
        }
        td {
            position: relative;
            &:hover {
                &:before {
                    content: "";
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: -9999px;
                    bottom: -9999px;
                    /* background-color: rgba(255,255,255,0.2); */
                    z-index: -1;
                }
            }
        }
    }


.bet-container {
    position: fixed;
    bottom: 0;
    margin-bottom: 70px;
    width: 100px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.25em;
    color: white;
    z-index: 100;
    visibility: visible;
    opacity: 1;
}
.main-image-wrapper img {
    width: 100%;
}
.video-container {
    height: 500px;
    width: 100%;
}
.notice-bar {
    margin-top: -40px;
    z-index: 1;
    /* color: white; */
    font-size: 20px;
    /* background: rgba(0, 0, 0, 0.5); */
    color: #0D3B1A;
    background: rgba(232, 185, 35, 0.35);
}
.twod-threed-cards {
    height: 200px;
}
.live-number {
    font-weight: bold;
    font-size: 25px;
}
.live-result {
    font-weight: bolder;
    font-size: 60px;
    animation-name: live-number-animation;
    animation-duration: 2s;
    animation-iteration-count: infinite;
}
.not-live-text {
    font-weight: bold;
    font-size: 24px;
}
.cards-container {
    display: flex;
    flex-wrap: wrap;
}
.card-body {
    padding: 0px !important;
}
.cards-container-mobile {
    display: none;
}
@keyframes live-number-animation {
    from {
        color: white;
    }
    to {
        color: #0D3B1A;
    }
}

@media (max-width: 768px) {
    .video-container {
        height: 300px;
        width: 100%;
    }
    .main-wrapper {
        padding: 7px !important;
    }
    .notice-bar {
        margin-top: 0px;
        height: 30px;
        z-index: 1;
        font-size: 13px;
        color: #0D3B1A;
        background: rgba(232, 185, 35, 0.35);
    }
    .live-number {
        font-weight: bold;
        font-size: 20px;
    }
    .live-result {
        font-weight: bolder;
        font-size: 37px;
    }

    .cards-container {
        display: none;
    }
    .cards-container-mobile {
        padding: 0px !important;
        margin-top: 15px !important;
        display: flex;
        flex-wrap: wrap;
    }
    .home-cards {
        padding-left: 10px;
        padding-right: 10px;
    }
    .card-body {
        padding: 0px !important;
    }
    .not-live-text {
        font-size: 18px;
        padding-left: 10px;
        padding-right: 10px;
    }
}
</style>
